import axios, { AxiosRequestConfig } from "axios";

import { axiosInstance } from "../api/axiosConfig";

export const getAssets = async (options: AxiosRequestConfig) => {
  return axiosInstance.get("utils/assets", options);
};

export const getAssetDetails = async (options: AxiosRequestConfig) => {
  return axiosInstance.get("trade-engine/exposure-details", options);
};

export const getAssetSparkLineData = async (symbol: string) => {
  return await axios.get(
    `${process.env.NEXT_PUBLIC_TWELEVE_API_URL}?symbol=${symbol}/usd&interval=1h&outputsize=24&apikey=${process.env.NEXT_PUBLIC_TWELVE_DATA_API_KEY}&timezone=UTC`,
  );
};

export const getBaseAssets = async (options: AxiosRequestConfig) => {
  return await axiosInstance.get("trade-engine/tradable/symbols", options);
}